import { ReactElement } from 'react';

import quoteIcon from 'images/quote.svg';
import { IProps } from './types';
import * as S from './styles';

export function SliceQuote({ slice: { primary } }: IProps): ReactElement {
  return (
    <S.Wrapper className="slice-item slice-quote">
      <img src={quoteIcon} alt="Icon" />
      <p>{primary?.quote}</p>
    </S.Wrapper>
  );
}

SliceQuote.componentName = 'quote';
